import BasicInput from '@opploans/basic-input-component/BasicInput';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

export default {
  defaultNextPage: 'page-5.3',
  content: [
    configureProgressBar(20),
    configureTitle("What is your spouse's name?"),
    {
      component: BasicInput,
      name: 'spouseFirstName',
      props: {
        id: 'spouseFirstName',
        label: 'Spouse First Name',
        maxLength: 40,
        formControlStyle: {
          marginBottom: '1.5rem'
        }
      }
    },
    {
      component: BasicInput,
      name: 'spouseLastName',
      props: {
        id: 'spouseLastName',
        label: 'Spouse Last Name',
        maxLength: 40,
        formControlStyle: {
          marginBottom: '1.5rem'
        }
      }
    },
    nextButtonConfig('page-5.2')
  ]
};
